import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';
import useReceipts from '@/utils/hooks/swr/pricing/useReceipts';

//Components
import { PageLoading } from '@/components/pages/settings/subscription-invoices/PageContent/PageLoading';
import { ErrorPage } from '@/components/pages/settings/subscription-invoices/PageContent/ErrorPage';
import { NoSubscription } from '@/components/pages/settings/subscription-invoices/PageContent/NoSubscription';
import { SubscriptionPage } from '@/components/pages/settings/subscription-invoices/PageContent/SubscriptionPage';

type ContentProps = {
    togglePlanModal: () => void;
};
export function Content({ togglePlanModal }: ContentProps) {
    const { subscription, isLoading, subscriptionError } = useSubscription();
    const { isLoadingInitialData: isLoadingReceipts, receiptsError } = useReceipts();

    if (isLoading || isLoadingReceipts) {
        return <PageLoading />;
    }
    if (subscriptionError || receiptsError) {
        return <ErrorPage />;
    }

    if (!subscription.product_key) {
        return <NoSubscription subscription={subscription} togglePlanModal={togglePlanModal} />;
    }

    return <SubscriptionPage togglePlanModal={togglePlanModal} />;
}
